import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { isLoggedIn } from '../../utils/auth';

// Get the base URL and auth header
const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4611/auth';

export const stopWordsApi = createApi({
  reducerPath: 'stopWordsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseUrl}`,
    prepareHeaders: (headers) => {
      // Get token from localStorage
      const token = localStorage.getItem('token');
      if (token && isLoggedIn()) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['StopWords'],
  endpoints: (builder) => ({
    getStopWords: builder.query({
      query: () => '/stop-words',
      providesTags: ['StopWords'],
    }),
    setStopWords: builder.mutation({
      query: (stopWords) => ({
        url: '/stop-words',
        method: 'POST',
        body: { stop_words: stopWords },
      }),
      invalidatesTags: ['StopWords'],
    }),
  }),
});

export const {
  useGetStopWordsQuery,
  useSetStopWordsMutation,
} = stopWordsApi; 